import dynamic from "next/dynamic";

export const HomeAboutContent = dynamic(() => import("./component"));
